<template>
 <div>Logging in...</div>
</template>
 
<script>
import axios from "axios";
export default {
 name: "AuthCallback",
 async mounted() {
 const loginData = await axios
 .create({
 baseURL:
 process.env.VUE_APP_API_BASE_URL +
 "auth/discord/callback?access_token=" +
 this.$route.query.access_token
 })
 .get()
 .catch(error => {
 // eslint-disable-next-line 
 console.debug('Request token failed: ', error);
 window.location = "/accessdenied";
 });
 if (!loginData || !loginData.data.jwt) {
 console.debug('No JWT returned in login data');
 window.location = "/accessdenied";
 } else {
   console.log(loginData);
 localStorage.setItem('jwt', loginData.data.jwt);
 localStorage.setItem('user', loginData.data.user);
//  localStorage.setItem('ntLogin', loginData.data.user.username);
 
 window.location = localStorage.getItem('redirect') ? localStorage.getItem('redirect') : "/";
 }
 }
};
</script>